import { render, staticRenderFns } from "./tabbarComponent.vue?vue&type=template&id=75ad9949"
import script from "./tabbarComponent.vue?vue&type=script&lang=js"
export * from "./tabbarComponent.vue?vue&type=script&lang=js"
import style0 from "./tabbarComponent.vue?vue&type=style&index=0&id=75ad9949&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports